export default {
  newDesign: true,
  slotFirst: true,
  parameters: {
    landing_id: "ItfwdFCSl",
    segment: 9,
    success_page: 'it_thankyou_page_fwd',
  },
  title: "Corso online gratuito di creazione di animazioni | Kodland",
  downtimeUrl: "https://www.kodland.org/it",
  startPage: {
    title:
      "Rispondi a 5 domande e ricevi un invito a un CORSO ONLINE GRATUITO di creazione di animazioni!",
    subtitle:
      "Tuo figlio/a si cimenterà nella creatività digitale, animazione, illustrazione, modellazione 3D, design.",
    image: {
      url: "/welcome/italy_fwd_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/italy_fwd_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Clicca qui per iscriverti 🚀 ",
  },
  stopPage: {
    "image": "/welcome/quizV2/no-computer.png",
    "title": "Grazie per aver scelto la nostra piattaforma educativa!",
    "subtitle": "Si prega di notare che i nostri corsi richiedono una tastiera e un mouse; quindi telefoni, tablet e dispositivi privi di queste caratteristiche non sono compatibili. Per rimanere sempre aggiornato/a sulle nostre novità, puoi seguirci su <a href=\"https://www.instagram.com/kodland.it/\" target=\"_blank\">Instagram</a> 💙"
  },
  quizRotateBySteps: {
    1: {
      question: "Quanto tempo trascorre tuo/a figlio/a con i dispositivi elettronici al giorno?",
      answers: [
        "😍 1 ora",
        "🙂 2-3 ore",
        "😔 più di 4 ore",
      ],
    },
    2: {
      question: "Qual è la personalità di tuo/a figlio/a?",
      subtitle: "La risposta ci aiuterà a scegliere la corretta metodologia di insegnamento",
      answers: [
        "🥳 Attivo, comunica tanto",
        "😌 Timido",
        "🤩 Sognatore",
        "🤫 Tranquillo, trascorre molto tempo da solo",
        "🤔 Non sa bene cosa vuole",
        "❓La mia proposta (Te la dirò in classe)"
      ],
    },
    3: {
      question: "Come valuti la motivazione di tuo/a figlio/a ad apprendere?",
      answers: [
        "😍 Alta",
        "😌 Bassa",
        "🤔 Normale",
      ],
    },
    4: {
      title: "Quanti anni ha tuo figlio/a?",
      type: "age",
      button: "",
    },
    5: {
      question: "Hai un computer/portatile per studiare?",
      answers: [
        "✔️ Sì",
        {
          answer: "❌ No",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "Congratulazioni! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Clicca su '📆 Prenota una lezione' per completare la registrazione. Ti invieremo un video corso e l'accesso alla nostra piattaforma non appena riceveremo la tua richiesta.",
      button: "📆 Prenota una lezione",
    },
    7: {
      title:
        "Quando vuoi che tu e tuo/a figlio/a facciate la prima lezione gratuita insieme?",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title: "Prenota una lezione gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Perfetto. Manca l'ultimo passaggio!",
    },
    9: {
      title:
        "Controlla questi dettagli per completare la registrazione ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
      button: "Cos'altro?",
    },
    10: {
      title: "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
      typeInfo: "whatsapp",
      subtitle:
        "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
      button: "Cos'altro?",
    },
    11: {
      title: "La lezione si svolgerà sulla nostra piattaforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
      button: "Ho capito ✅",
    }
  },
};
